const transports = [
  {
    code: 'flight',
    label: 'Avion',
    hasDeparture: true
  },
  {
    code: 'bus',
    label: 'Autocar',
    hasDeparture: true
  },
  {
    code: 'own',
    label: 'Propriu',
    hasDeparture: false
  }
]

export {
  transports
}
